export enum FieldType {
    AlphaNumeric = 0,
    Currency = 1,
    Integer = 2,
    Date = 3,
    Lookup = 4,
    Decimal = 5,
    ZipCode = 6,
    DecimalSinglePrecision = 7,
}
